/**
 * Production MySQL Database Schema for Saints Tech Solutions
 * Can be previewed, copied, or downloaded from the Admin Console.
 */
export const PRODUCTION_MYSQL_SCHEMA = `-- ============================================================================
-- SAINTS TECH SOLUTIONS - PRODUCTION MYSQL DATABASE SCHEMA (v1.0.0)
-- Target RDBMS: MySQL 8.0+ / MariaDB 10.4+ (cPanel / phpMyAdmin compatible)
-- Character Set: utf8mb4, Collation: utf8mb4_unicode_ci
-- Storage Engine: InnoDB (Full ACID compliance & transaction safety)
-- ============================================================================

SET NAMES utf8mb4;
SET FOREIGN_KEY_CHECKS = 0;
SET SQL_MODE = "NO_AUTO_VALUE_ON_ZERO,STRICT_TRANS_TABLES,ERROR_FOR_DIVISION_BY_ZERO,NO_ENGINE_SUBSTITUTION";

-- ----------------------------------------------------------------------------
-- 1. TABLE: products (Core Commercial Equipment Inventory)
-- ----------------------------------------------------------------------------
CREATE TABLE IF NOT EXISTS \`products\` (
  \`id\` VARCHAR(80) NOT NULL PRIMARY KEY,
  \`name\` VARCHAR(255) NOT NULL,
  \`category\` VARCHAR(64) NOT NULL,
  \`tagline\` VARCHAR(255) NOT NULL,
  \`description\` TEXT NOT NULL,
  \`capacity\` VARCHAR(100) NOT NULL,
  \`material\` VARCHAR(120) NOT NULL DEFAULT 'Food-Grade Stainless Steel AISI 304',
  \`power\` VARCHAR(120) NOT NULL DEFAULT '240V AC 50Hz',
  \`price_ksh\` DECIMAL(12, 2) NOT NULL,
  \`original_price_ksh\` DECIMAL(12, 2) NULL,
  \`in_stock\` TINYINT(1) NOT NULL DEFAULT 1,
  \`image_url\` VARCHAR(500) NOT NULL,
  \`features_json\` JSON NOT NULL,
  \`specs_json\` JSON NOT NULL,
  \`seo_json\` JSON NOT NULL,
  \`created_at\` DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
  \`updated_at\` DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP ON UPDATE CURRENT_TIMESTAMP,
  INDEX \`idx_prod_category\` (\`category\`),
  INDEX \`idx_prod_stock\` (\`in_stock\`),
  INDEX \`idx_prod_price\` (\`price_ksh\`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_unicode_ci;

-- ----------------------------------------------------------------------------
-- 2. TABLE: blog_posts (Technical Articles, Industry Blueprints & Case Studies)
-- ----------------------------------------------------------------------------
CREATE TABLE IF NOT EXISTS \`blog_posts\` (
  \`id\` VARCHAR(80) NOT NULL PRIMARY KEY,
  \`slug\` VARCHAR(191) NOT NULL UNIQUE,
  \`title\` VARCHAR(255) NOT NULL,
  \`excerpt\` TEXT NOT NULL,
  \`category\` VARCHAR(100) NOT NULL,
  \`author_name\` VARCHAR(120) NOT NULL DEFAULT 'Saints Tech Team',
  \`author_role\` VARCHAR(160) NOT NULL DEFAULT 'Technical & Engineering Team, Saints Tech Solutions',
  \`author_avatar\` VARCHAR(10) NOT NULL DEFAULT 'ST',
  \`published_date\` VARCHAR(50) NOT NULL,
  \`read_time\` VARCHAR(30) NOT NULL DEFAULT '6 min read',
  \`image_url\` VARCHAR(500) NOT NULL,
  \`featured\` TINYINT(1) NOT NULL DEFAULT 0,
  \`views\` INT UNSIGNED NOT NULL DEFAULT 0,
  \`likes\` INT UNSIGNED NOT NULL DEFAULT 0,
  \`key_takeaways_json\` JSON NOT NULL,
  \`table_of_contents_json\` JSON NOT NULL,
  \`content_sections_json\` JSON NOT NULL,
  \`related_product_ids_json\` JSON NOT NULL,
  \`seo_json\` JSON NOT NULL,
  \`comments_json\` JSON NOT NULL,
  \`created_at\` DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
  \`updated_at\` DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP ON UPDATE CURRENT_TIMESTAMP,
  INDEX \`idx_blog_category\` (\`category\`),
  INDEX \`idx_blog_featured\` (\`featured\`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_unicode_ci;

-- ----------------------------------------------------------------------------
-- 3. TABLE: leads_rfq (Customer Requests for Quotation & Inquiries)
-- ----------------------------------------------------------------------------
CREATE TABLE IF NOT EXISTS \`leads_rfq\` (
  \`id\` VARCHAR(64) NOT NULL PRIMARY KEY,
  \`customer_name\` VARCHAR(120) NOT NULL,
  \`business_name\` VARCHAR(160) NOT NULL,
  \`phone\` VARCHAR(40) NOT NULL,
  \`email\` VARCHAR(191) NOT NULL,
  \`county\` VARCHAR(80) NOT NULL,
  \`notes\` TEXT NULL,
  \`items_json\` JSON NOT NULL,
  \`total_ksh\` DECIMAL(12, 2) NOT NULL DEFAULT 0.00,
  \`status\` VARCHAR(40) NOT NULL DEFAULT 'New',
  \`created_at\` DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
  \`updated_at\` DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP ON UPDATE CURRENT_TIMESTAMP,
  INDEX \`idx_lead_status\` (\`status\`),
  INDEX \`idx_lead_county\` (\`county\`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_unicode_ci;

-- ----------------------------------------------------------------------------
-- 4. TABLE: media_library (Uploaded Product Photos & Workshop Assets)
-- ----------------------------------------------------------------------------
CREATE TABLE IF NOT EXISTS \`media_library\` (
  \`id\` VARCHAR(80) NOT NULL PRIMARY KEY,
  \`name\` VARCHAR(255) NOT NULL,
  \`url\` LONGTEXT NOT NULL,
  \`category\` VARCHAR(100) NULL,
  \`size\` VARCHAR(50) NULL,
  \`uploaded_at\` VARCHAR(80) NOT NULL,
  \`created_at\` DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP
) ENGINE=InnoDB DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_unicode_ci;

-- ----------------------------------------------------------------------------
-- 5. TABLE: site_images (Database-backed static website image assignments)
-- ----------------------------------------------------------------------------
CREATE TABLE IF NOT EXISTS \`site_images\` (
  \`image_key\` VARCHAR(100) NOT NULL PRIMARY KEY,
  \`image_url\` LONGTEXT NOT NULL,
  \`updated_at\` DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP ON UPDATE CURRENT_TIMESTAMP
) ENGINE=InnoDB DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_unicode_ci;

-- ----------------------------------------------------------------------------
-- 6. TABLE: admins (Role-based access & system administrators)
-- ----------------------------------------------------------------------------
CREATE TABLE IF NOT EXISTS \`admins\` (
  \`id\` INT UNSIGNED AUTO_INCREMENT PRIMARY KEY,
  \`email\` VARCHAR(191) NOT NULL UNIQUE,
  \`password_hash\` VARCHAR(255) NOT NULL,
  \`full_name\` VARCHAR(120) NOT NULL,
  \`role\` VARCHAR(50) NOT NULL DEFAULT 'SUPER_ADMIN',
  \`created_at\` DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP
) ENGINE=InnoDB DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_unicode_ci;

SET FOREIGN_KEY_CHECKS = 1;
`;
